import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook to manage the document title with i18n support.
 */
export function useDocumentTitle(titleKey: string, namespace: 'global') {
    const { t, i18n } = useTranslation(namespace);

    useEffect(() => {
        const translatedTitle = t(titleKey);
        document.title = translatedTitle;
    }, [t, titleKey, i18n.language]); // Re-run effect when titleKey or language changes
}
